module.exports = "/images/formations.svg?80a7155c3f1b7120222c1fe29466e183";